import { styled } from "@mui/material";

export const PlayerIcon = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "contain",
});
